import React, { useEffect } from 'react';
import styled from 'styled-components';

import FlexContainer from 'components/lib/ui/FlexContainer';
import ModalCard from 'components/lib/ui/ModalCard';
import PrimaryButton from 'components/lib/ui/button/PrimaryButton';
import PostContent from 'components/posts/PostContent';

import referralsWhatsNewPost from 'common/lib/posts/referralsWhatsNewPost';
import type { Post } from 'common/lib/posts/types';
import { color, spacing } from 'common/lib/theme/dynamic';
import useParams from 'lib/hooks/useParams';
import { useWhatsNew } from 'lib/hooks/useWhatsNew';

const Footer = styled(FlexContainer).attrs({ justifyEnd: true })`
  border-top: 1px solid ${color.grayBackground};
  padding: ${spacing.default} ${spacing.xlarge};
`;

const SLUG_TO_POST: { [slug: string]: Post } = {
  referrals: referralsWhatsNewPost,
};

type Props = {
  onClose: () => void;
};

const WhatsNewModal = ({ onClose }: Props) => {
  const { dismissWhatsNew } = useWhatsNew();

  const { slug } = useParams();
  const post = slug && SLUG_TO_POST[slug];

  useEffect(() => {
    if (!post) {
      onClose();
    } else {
      dismissWhatsNew();
    }
  }, [dismissWhatsNew, post, onClose]);

  if (!post) {
    return null;
  }

  const onClickDone = () => {
    dismissWhatsNew();
    onClose();
  };

  return (
    <ModalCard title="What's new">
      <PostContent post={post} />

      <Footer>
        <PrimaryButton size="medium" onClick={onClickDone}>
          Done
        </PrimaryButton>
      </Footer>
    </ModalCard>
  );
};

export default WhatsNewModal;
